(function() {

  /* === SLIDESHOW DOTS POSITIONING === */
  function positionDotsOnImage() {
    if (window.innerWidth > 749) return;
    var sw = document.querySelector('slideshow-component.mobile-text-below');
    if (!sw) return;
    var media = sw.querySelector('.slideshow__media');
    var controls = sw.querySelector('.slideshow__controls');
    if (!media || !controls) return;
    var imgH = media.offsetHeight;
    if (imgH < 50) {
      setTimeout(positionDotsOnImage, 150);
      return;
    }
    controls.style.top = (imgH - 40) + 'px';
    controls.style.bottom = 'auto';
  }

  /* === RICH TEXT: LEFT ALIGN ON MOBILE === */
  function alignRichTextLeft() {
    if (window.innerWidth > 749) return;
    var blocks = document.querySelectorAll('.rich-text__blocks');
    blocks.forEach(function(el) {
      el.style.setProperty('text-align', 'left', 'important');
      var children = el.querySelectorAll('*');
      children.forEach(function(child) {
        child.style.setProperty('text-align', 'left', 'important');
      });
      var buttons = el.querySelector('.rich-text__buttons');
      if (buttons) buttons.style.setProperty('justify-content', 'flex-start', 'important');
    });
    var wrappers = document.querySelectorAll('.rich-text__wrapper');
    wrappers.forEach(function(el) {
      el.style.setProperty('justify-content', 'flex-start', 'important');
    });
  }

  function init() {
    positionDotsOnImage();
    alignRichTextLeft();
    var imgs = document.querySelectorAll(
      'slideshow-component.mobile-text-below .slideshow__media img'
    );
    imgs.forEach(function(img) {
      if (!img.complete) img.addEventListener('load', positionDotsOnImage);
    });
    setTimeout(positionDotsOnImage, 300);
    setTimeout(positionDotsOnImage, 800);
    setTimeout(alignRichTextLeft, 300);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('resize', function() {
    positionDotsOnImage();
    alignRichTextLeft();
  });

})();
